import React from "react";
import { Modal, ModalHeader, ModalBody } from "reactstrap";

const EditModal = ({ isOpen, toggle, section, Component, dropdownData }) => {
  return (
    <Modal isOpen={isOpen} toggle={toggle} size="xl">
      <ModalHeader toggle={toggle}>
        {section} 
      </ModalHeader>
      <ModalBody>
        {Component ? <Component dropdownData={dropdownData} /> : <p>No component found</p>}
      </ModalBody>
    </Modal>
  );
};

export default EditModal;
